// accountList comes from backend response!
export function getSlotUsageFromAccountList(accountList) {
    let usedSlots = [];
    if (!Array.isArray(accountList)) return usedSlots;
    accountList.forEach((sponsor) => {
      (sponsor.sponsorPlacementList || []).forEach((placement) => {
        usedSlots.push({
          sponsorId: sponsor.sponsorId,
          type: placement.sponsorPlacementType,
          slot: Number(placement.slot ?? placement.weeklyEmailSlot ?? 0),
          startDate: placement.startDate,
          endDate: placement.endDate,
        });
      });
    });
    return usedSlots;
  }
  
  // Only disables for other sponsors, ignores self on Update!
  export function isSlotTaken({ usedSlots, slot, type, selectedStart, selectedEnd, currentSponsorId }) {
    return usedSlots.some((item) => {
      if (!item.startDate || !item.endDate) return false;
      if (item.type !== type) return false;
      if (Number(item.slot) !== Number(slot)) return false;
      if (item.sponsorId === currentSponsorId) return false; // allow self to keep
      // Overlap
      return (
        new Date(selectedStart) <= new Date(item.endDate) &&
        new Date(selectedEnd) >= new Date(item.startDate)
      );
    });
  }
  